import {
    type RejectCommercialOpportunityRequestResponseType,
    type RejectCommercialOpportunityRequestRequestType
} from "./type";
import {
    request
} from "../request";

const rejectCommercialOpportunityRequest = async (
    params: RejectCommercialOpportunityRequestRequestType
): Promise<RejectCommercialOpportunityRequestResponseType> => {
    return await request<RejectCommercialOpportunityRequestResponseType>(
        "/request/rejectCommercialOpportunityRequest",
        {
            body: JSON.stringify(params),
            method: "POST"
        }
    );
};
export default rejectCommercialOpportunityRequest;
